// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OtWy","col":"styles_col__2zy8W"};